export const ENTITY_NAMES = {
  SERIES: "Series",
  LAB: "Lab",
  RUN: "Group",
  STUDENT: "Student",
  PAYMENT: "Payment",
} as const;

export type EntityName = keyof typeof ENTITY_NAMES;

export const TABLE_NAMES = {
  SERIES: "series",
  LABS: "labs",
  RUNS: "runs",
  ENROLLMENTS: "enrollments",
  PAYMENTS: "payments",
};
